export class NitrogenGeneratorData {
    generatorId: number;
    runningHours: number;
    runningHoursLoaded: number;
    runningHoursUnloaded: number;

    constructor(generatorId: number, runningHours: number, runningHoursLoaded: number, runningHoursUnloaded: number) {
        this.generatorId = generatorId;
        this.runningHours = runningHours;
        this.runningHoursLoaded = runningHoursLoaded;
        this.runningHoursUnloaded = runningHoursUnloaded;
    }
}
